export default __webpack_public_path__ + "static/media/permit_submitted.c870ebd8.svg";